<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <ward-form :itemId="id" formType="Edit" subTitle="Edit Ward"></ward-form>
      </div>
    </div>
  </div>
</template>

<script>
import WardForm from "@/views/ward/components/Form.vue";

export default {
  name: "edit-ward",
  data(){
    return {
      id : this.$route.params.id
    }
  },
  components: {
    WardForm,
  }
};
</script>